import React from "react";
import { AssetHeader } from "./Assets.styled";
import Sales from "../admin/components/config/sales/Sales";
import DashboardLayout from "../Layout/DashboardLayout";

const SalesManagement = () => {
  return (
    <DashboardLayout pageTitle="Sales">
      <AssetHeader data-aos="fade-right">
        <h3>Sales Management</h3>
      </AssetHeader>
      <Sales />
    </DashboardLayout>
  );
};

export default SalesManagement;
